<?xml version="1.0" encoding="UTF-8"?>
<svg width="11px" height="11px" viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M6.67857143,0 L6.678,4.321 L11,4.32142857 L11,6.67857143 L6.678,6.678 L6.67857143,11 L4.32142857,11 L4.321,6.678 L0,6.67857143 L0,4.32142857 L4.321,4.321 L4.32142857,0 L6.67857143,0 Z" id="Combined-Shape" fill="#B0B0B0"></path>
    </g>
</svg>